import React, { useContext } from "react";
import Brain from "../../components/assets/brain (1).svg";
import { Link } from "react-router-dom";
import { AuthContext } from "../../AuthContext";
const ConfirmLogin = () => {
  const authContext = useContext(AuthContext);

  return (
    <div id="welcom2">
      <div
        style={{ height: "87vh" ,  }}
        className="d-flex flex-column justify-content-center align-items-center  pb-2 w-75 mx-auto"
      >
        <img style={{width:"100px"}} src  ={Brain} alt='logo'/>
          <p className="my-4">  YOU NEED TO LOGIN OR SIGNUP</p>
          
        <div   className="d-flex flex-row justify-content-between gap-5 align-items-center pt-3 pb-2">
        
              <button className=" px-3 py-2  border rounded-pill bg-white text-white">
              <Link
            className="w-50 px-3 py-1  rounded-pill  text-danger"
            to={`${
              authContext.auth && authContext.auth.user ? "/test" : "/login"
            }`}
          >
            LOG IN
          </Link>
        </button>
              <button className=" px-3 py-2  border rounded-pill bg-white text-white">
          <Link
            className="w-50 px-3 py-1  rounded-pill  text-danger"
            to={`${
              authContext.auth && authContext.auth.user ? "/test" : "/register"
            }`}
          >
          CREATE ACCOUNT
          </Link>
        </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmLogin;
